export default "b {\n  font-weight: 500;\n}";